var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgMediaLocationSeparator = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 12,
  height: 12
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M8 4.5 4.21.71a1 1 0 0 0-1.42 0l-.08.08a1 1 0 0 0 0 1.42L6.5 6 2.71 9.79a1 1 0 0 0 0 1.42l.08.08a1 1 0 0 0 1.42 0L8 7.5 9.5 6z"
})));
export default SvgMediaLocationSeparator;